const BOT_USER_AGENT_PATTERN = /prerender|headlesschrome|bot|crawler|spider/i;

// "bot" também aparece no nome de aparelhos de gente de verdade.
const HUMAN_DEVICE_PATTERN = /cubot/gi;

type TBrowserNavigator = {
  userAgent: string;
  webdriver?: boolean;
};

/**
 * Crawlers e o Chrome headless do Prerender.io (PrerenderMiddleware) não
 * carregam o widget: ele só atrasaria a captura e sujaria o HTML servido.
 */
export default function isBotBrowser({
  userAgent,
  webdriver,
}: TBrowserNavigator): boolean {
  if (webdriver) return true;

  return BOT_USER_AGENT_PATTERN.test(
    userAgent.replace(HUMAN_DEVICE_PATTERN, ''),
  );
}
